import React, { useState } from "react";
import { Button, Box, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormGroup, FormControlLabel, FormControl, Select, TextField } from "@mui/material";
import StringTuner from "./StringTuner";
import styled from "@emotion/styled";
import styles from "../styles";
import SettingsIcon from '@mui/icons-material/Settings';

/**
 * Represents a component for controlling the tuning of guitar strings.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {number} props.stringCount - The number of guitar strings.
 * @param {string[]} props.tuning - The current tuning of the guitar strings.
 * @param {function} props.setTuning - The function to update the tuning of the guitar strings.
 * @param {boolean} props.setShowTuningOnNut - The function to update whether to show the tuning on the nut.
 * @param {boolean} props.showTuningOnNut - Indicates whether the tuning is shown on the nut.
 * @returns {JSX.Element} The TuningControl component.
 */
const TuningControl = ({ stringCount, tuning, setTuning, setShowTuningOnNut, showTuningOnNut, disabled }) => {

    const [open, setOpen] = useState(false);
    const [stringTunings, setStringTunings] = useState(tuning); //temporary state to update the tuning before saving

    const handleClick = () => {
        setOpen(!open);
    };

    const handleSave = () => {
        setTuning(stringTunings);
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const StyledDiv = styled.div`
        display: flex;
        justify-content: space-between;
    `;

    const notes = ["C", "C#", "D", "D#", "E", "F", "F#", "G", "G#", "A", "A#", "B"];



    const handleStringTuningChange = (index, value) => {
        const newStringTunings = [...stringTunings];
        newStringTunings[index] = value;
        setStringTunings(newStringTunings);
    };

    const handleTuningChecked = (event) => {
        setShowTuningOnNut(event.target.checked);
    };

    const buttonStyle = {
        color: "#e5893e",
    };

    return (
        <Box display="flex" flexDirection="row">
            <Button
                id="tuning-control-button"
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
                variant="outlined"
                size='small'
                sx={{ marginRight: '5px' }}
                endIcon={<SettingsIcon />}
                disabled={disabled}
            >
                Tuning
            </Button>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth={true}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ width: "md" }}
            >
                <DialogTitle>Tuning Control</DialogTitle>
                <DialogContent>
                    {Array.from({ length: stringCount }, (_, i) => i + 1).map((stringNumber) => (
                        <StringTuner key={stringNumber} stringNumber={stringNumber} stringTunings={stringTunings} setStringTunings={setStringTunings} />
                    ))}

                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={showTuningOnNut}
                                onChange={handleTuningChecked}
                                inputProps={{ "aria-label": "Show fret note" }}
                            />
                        }
                        label="Show String Tuning on Nut"
                    />


                </DialogContent>

                <DialogActions>
                    <Button variant="contained" onClick={handleSave}>
                        Save Tuning
                    </Button>
                    <Button variant="contained" onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>



            </Dialog>
        </Box >
    );
};

export default TuningControl;
